import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker, InfoWindow } from 'react-google-maps';

import ImgPedestrianGrey from '../image/pedestrian-grey.png';

import { getConfig } from '../configuracao/configLocal';
import { downloadCroqui } from '../controlador/controladorActions';
import { Button } from 'react-bootstrap';

import {
  getControladorFase,
  getControladorCoresGF,
  getControladorCoresGT,
  clearMapaFase,
  getInicioMapa,
  getPluviometroMapaData,
  setMapaFaseFromSocket,
  setMapaFaseLive,
} from './faseActions';
import socketService from '../services/socketService';
import {
  activateMapaFaseLive,
  wireMapaFaseSocketBridge,
  deactivateMapaFaseLive,
  setMapaFaseLiveAtivo,
} from './mapaFaseSocketBridge';
import {
  corPiscanteIntervaloAtiva,
  shouldAcceptMenorSnapshotFull,
  fasesDoGrupo,
} from './mapaFaseUtils';
import { coletarPinsFase, clearArrowIconCache } from './mapaFaseMarkerUtils';
import { renderMarcadoresControlador } from './mapaControladorMap';
import MapaControladorGaveta from './mapaControladorGaveta';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import { executarResetControlador } from './mapaControladorCadastro';
import axiosInstance from '../main/axios';
import {
  getConfControladorGrupoList,
  getGrupoFisicoPluviometroList,
  getConfControladorGrupoPluviometroList,
} from '../common/selectdb/selectdbAtions';
import SelectConfGrupoFisico, { GRUPO_TODOS } from '../common/selectdb/selectConfGrupoFisico';
import SelectConfGrupoFisicoPluviometro from '../common/selectdb/selectConfGrupoFisicoPluviometro';
import swal from 'sweetalert2';
import { toastr } from 'react-redux-toastr';

import CloudOverlay from './CloudOverlay';
import { downloadMapaFaseKmz } from './mapaFaseKmzExport';
import './mapaFaseGeral.css';

const MAP_HTTP_TIMEOUT_MS = 12000;
const MAP_KEEPALIVE_MS = 30000;
const MAP_HEALTH_CHECK_MS = 90000;
const MAP_HTTP_FULL_SYNC_MS = 60000;
const MAP_SOCKET_BOOTSTRAP_MS = 1000;
/** Sem interação nem foco por esse tempo: pausa sozinho e libera a ponte TCP. */
const MAP_IDLE_PAUSE_MS = 15 * 60 * 1000;
/**
 * Só suspende a leitura depois de a aba ficar esse tempo oculta. Troca rápida de
 * aba (conferir cor em outra tela) não pode apagar os pins.
 */
const MAP_HIDDEN_SUSPEND_MS = 60 * 1000;
const MAP_IDLE_EVENTS = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart'];

const MAPA_SELECT_STYLE = {
  padding: '6px 10px',
  fontSize: '13px',
  fontWeight: '500',
  border: '1px solid #ced4da',
  borderRadius: '6px',
  backgroundColor: '#fff',
  color: '#333',
  cursor: 'pointer',
  minWidth: '200px',
  height: '34px',
  boxShadow: 'none',
};
const MAP_SOCKET_BOOTSTRAP_MAX = 60;

class MapaFaseGeral extends Component {
  constructor(props) {
    super(props);

    const grupo = getConfig('grupo');
    if (+grupo) {
      this.props
        .getInicioMapa(grupo)
        .then(response => {
          if (parseInt(response.payload.data.latitude, 10) === 1) {
            swal({
              type: 'warning',
              title: 'Grupo físico sem controlador cadastrado!',
            });
          }
          this.setState({ inicioMapa: this.props.inicioMapa, carregandoInicioMapa: false });
        })
        .catch(() =>
          this.setState({
            carregandoInicioMapa: false,
            erroCarregamentoMapa: 'Não foi possível carregar o centro do mapa. Verifique se o banco de dados está acessível.',
          }),
        );
    }

    this.renderMarker = this.renderMarker.bind(this);
    this.handleToggleClose = this.handleToggleClose.bind(this);
    this.renderInfoWindow = this.renderInfoWindow.bind(this);
    this.renderStreetViewTooltip = this.renderStreetViewTooltip.bind(this);
    this.changeGrupo = this.changeGrupo.bind(this);
    this.changeDisplayTraffic = this.changeDisplayTraffic.bind(this);
    this.changeMapType = this.changeMapType.bind(this);
    this.changeVisualizacao = this.changeVisualizacao.bind(this);
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
    this.onMapLoad = this.onMapLoad.bind(this);
    this.tickMapa = this.tickMapa.bind(this);
    this.reiniciarIntervaloMapa = this.reiniciarIntervaloMapa.bind(this);
    this.setupMapaSocket = this.setupMapaSocket.bind(this);
    this.teardownMapaSocket = this.teardownMapaSocket.bind(this);
    this.handleMapaFaseSocketUpdate = this.handleMapaFaseSocketUpdate.bind(this);
    this.handleMapaFaseSubscribed = this.handleMapaFaseSubscribed.bind(this);
    this.iniciarKeepaliveMapa = this.iniciarKeepaliveMapa.bind(this);
    this.pararKeepaliveMapa = this.pararKeepaliveMapa.bind(this);
    this.ensureMapaSocketAtivo = this.ensureMapaSocketAtivo.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.startSocketBootstrap = this.startSocketBootstrap.bind(this);
    this.iniciarTempoReal = this.iniciarTempoReal.bind(this);
    this.pausarTempoReal = this.pausarTempoReal.bind(this);
    this.exportarKmz = this.exportarKmz.bind(this);
    this.registrarAtividade = this.registrarAtividade.bind(this);
    this.pausarManualmente = this.pausarManualmente.bind(this);
    this.retomarManualmente = this.retomarManualmente.bind(this);
    this.carregarControladoresMapa = this.carregarControladoresMapa.bind(this);
    this.handleDetalhesControlador = this.handleDetalhesControlador.bind(this);
    this.fecharGavetaControlador = this.fecharGavetaControlador.bind(this);
    this.solicitarResetControlador = this.solicitarResetControlador.bind(this);
    this.confirmarResetControlador = this.confirmarResetControlador.bind(this);
    this.cancelarResetControlador = this.cancelarResetControlador.bind(this);

    this._httpTickBusy = false;
    this._lastHttpFullSync = 0;
    this._mapaGruposAtuais = [];
    this._pausadoManualmente = false;
    this._suspenso = false;
    this._suspenderTimer = null;
    this._ultimaAtividade = Date.now();

    this.state = {
      openInfoWindowMarkerId: '',
      loop: 0,
      intervaloMapaFaseGeral: null,
      listContMap: [],
      loopList: [],
      inicioMapa: {},
      displayTraffic: false,
      mapTypeId: 'roadmap',
      mapZoom: 15,
      blinkOn: true,
      tipoVisualizacao: props.visualizacao || 'fases',
      pluviometroData: [],
      pluviometroDataAnterior: [],
      googleMapsReady: typeof window !== 'undefined' && !!(window.google && window.google.maps),
      isStreetView: false,
      selectedMarkerData: null,
      mapaSocketAtivo: false,
      modoTempoReal: false,
      tempoRealLoading: false,
      exportandoKmz: false,
      todosGrupos: false,
      pausadoPorInatividade: false,
      carregandoInicioMapa: !!+grupo,
      controladoresMapa: [],
      carregandoControladores: false,
      gavetaControlador: null,
      resetControladorAlvo: null,
      erroCarregamentoMapa: null,
    };
  }

  carregarControladoresMapa() {
    const grupos = this.gruposSelecionados();
    if (!grupos.length) {
      this.setState({ controladoresMapa: [], carregandoControladores: false });
      return Promise.resolve();
    }

    this.setState({ carregandoControladores: true });

    return Promise.all(grupos.map(gid => axiosInstance.get(`/fasesgeral/mapa/controladores/${gid}`)))
      .then(responses => {
        const merged = responses.reduce((acc, resp) => acc.concat(resp.data || []), []);
        this.setState({ controladoresMapa: merged, carregandoControladores: false });
      })
      .catch(() => {
        this.setState({ carregandoControladores: false });
        toastr.warning('Mapa de fases', 'Não foi possível carregar os controladores do grupo.');
      });
  }

  handleDetalhesControlador(c) {
    this.setState({
      gavetaControlador: c,
      openInfoWindowMarkerId: '',
      selectedMarkerData: null,
    });
  }

  fecharGavetaControlador() {
    this.setState({ gavetaControlador: null });
  }

  solicitarResetControlador(c) {
    this.setState({ resetControladorAlvo: c });
  }

  confirmarResetControlador() {
    const c = this.state.resetControladorAlvo;
    this.setState({ resetControladorAlvo: null });
    if (!c) return;
    executarResetControlador(c);
  }

  cancelarResetControlador() {
    this.setState({ resetControladorAlvo: null });
  }

  async exportarKmz() {
    if (this.state.tipoVisualizacao === 'pluviometrico') {
      toastr.warning('Exportação KMZ disponível apenas no modo Fases.');
      return;
    }

    const list = this.props.list || [];
    if (!list.length) {
      toastr.warning('Nenhuma fase com coordenadas para exportar.');
      return;
    }

    this.setState({ exportandoKmz: true });
    try {
      const grupo = getConfig('grupo');
      const resultado = await downloadMapaFaseKmz(list, { grupoId: grupo });
      toastr.success(`KMZ gerado com ${resultado.totalFeatures} posição(ões).`);
    } catch (error) {
      console.error('Erro ao exportar KMZ do mapa de fases:', error);
      toastr.error(error.message || 'Erro ao gerar arquivo KMZ.');
    } finally {
      this.setState({ exportandoKmz: false });
    }
  }

  /** Grupos que o mapa deve acompanhar. Em "todos os grupos", todos os visíveis. */
  gruposSelecionados() {
    if (this.state.todosGrupos) {
      return (this.props.listGrupoFisico || []).map(g => parseInt(g.id, 10)).filter(id => id > 0);
    }
    const grupo = parseInt(getConfig('grupo'), 10);
    return grupo > 0 ? [grupo] : [];
  }

  /** Grupo para endpoints que aceitam 0 = sem filtro (centro do mapa). */
  grupoParaInicioMapa() {
    return this.state.todosGrupos ? 0 : parseInt(getConfig('grupo'), 10) || 0;
  }

  deveUsarSocketMapa() {
    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';
    return !modoPluviometrico && this.props.config && this.props.config.mapa_fase_socket;
  }

  intervaloMapaMs() {
    // Com socket: HTTP como rede de segurança a cada 15 s (patches são imediatos).
    // Sem socket: legado 1 s (poller desligado ou ambiente antigo).
    return this.deveUsarSocketMapa() ? 15000 : 1000;
  }

  tickMapa() {
    try {
      if (!this.state.modoTempoReal) return;
      if (this._httpTickBusy) return;
      const grupos = this.gruposSelecionados();
      if (!grupos.length) return;

      const socketLive = this.deveUsarSocketMapa() && socketService.isMapaFaseSubscribedOk();
      if (socketLive) {
        const now = Date.now();
        if (this._lastHttpFullSync && now - this._lastHttpFullSync < MAP_HTTP_FULL_SYNC_MS) {
          return;
        }
        this._lastHttpFullSync = now;
      }

      this._httpTickBusy = true;
      if (this._httpTickWatchdog) {
        clearTimeout(this._httpTickWatchdog);
      }
      this._httpTickWatchdog = setTimeout(() => {
        this._httpTickBusy = false;
      }, MAP_HTTP_TIMEOUT_MS + 2000);

      const liberarHttp = () => {
        if (this._httpTickWatchdog) {
          clearTimeout(this._httpTickWatchdog);
          this._httpTickWatchdog = null;
        }
        this._httpTickBusy = false;
      };

      const modoPluviometrico =
        this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';

      const promessaComTimeout = promessa =>
        Promise.race([
          promessa,
          new Promise((_, reject) => setTimeout(() => reject(new Error('mapagf timeout')), MAP_HTTP_TIMEOUT_MS)),
        ]);

      if (modoPluviometrico) {
        promessaComTimeout(this.props.getPluviometroMapaData(this.grupoParaInicioMapa()))
          .then(response => {
            const novosDados = response.payload.data || [];
            const dadosProcessados = this.processarDadosPluviometricos(novosDados);
            this.setState({
              pluviometroDataAnterior: this.state.pluviometroData,
              pluviometroData: dadosProcessados,
            });
          })
          .catch(() => {})
          .finally(liberarHttp);
      } else {
        // Um snapshot por grupo; o reducer mescla sem apagar os demais.
        const buscas = grupos.map(gid => promessaComTimeout(this.props.getControladorCoresGF(gid)).catch(() => {}));
        Promise.all(buscas)
          .then(() => {
            if (this.state.modoTempoReal && this.state.tempoRealLoading) {
              this.setState({ tempoRealLoading: false });
            }
          })
          .catch(() => {})
          .finally(liberarHttp);
      }
    } catch (error) {
      this._httpTickBusy = false;
    }
  }

  pararKeepaliveMapa() {
    if (this._mapaKeepalive) {
      clearInterval(this._mapaKeepalive);
      this._mapaKeepalive = null;
    }
    if (this._mapaHealthCheck) {
      clearInterval(this._mapaHealthCheck);
      this._mapaHealthCheck = null;
    }
  }

  iniciarKeepaliveMapa() {
    this.pararKeepaliveMapa();
    if (!this.state.modoTempoReal || !this.deveUsarSocketMapa()) return;

    const ping = () => {
      const grupos = this.gruposSelecionados();
      if (grupos.length) {
        socketService.ensureMapaFaseLive(grupos);
      }
    };

    ping();
    this._mapaKeepalive = setInterval(ping, MAP_KEEPALIVE_MS);
    this._mapaHealthCheck = setInterval(() => this.ensureMapaSocketAtivo(), MAP_HEALTH_CHECK_MS);
  }

  ensureMapaSocketAtivo() {
    if (!this.state.modoTempoReal || !this.deveUsarSocketMapa()) return;

    const grupos = this.gruposSelecionados();
    if (!grupos.length) return;

    if (!socketService.isMapaFaseSubscribedOk()) {
      this.setupMapaSocket();
      socketService.ensureMapaFaseLive(grupos);
      if (!this.state.mapaSocketAtivo) {
        this.tickMapa();
      }
      return;
    }

    if (!this.state.mapaSocketAtivo) {
      this.setState({ mapaSocketAtivo: true }, () => this.reiniciarIntervaloMapa());
    }
  }

  registrarAtividade() {
    this._ultimaAtividade = Date.now();
  }

  iniciarVigiaInatividade() {
    this.pararVigiaInatividade();
    this.registrarAtividade();

    if (typeof window !== 'undefined') {
      MAP_IDLE_EVENTS.forEach(evt =>
        window.addEventListener(evt, this.registrarAtividade, { passive: true }),
      );
    }

    this._idleTimer = setInterval(() => {
      if (!this.state.modoTempoReal) return;
      if (Date.now() - this._ultimaAtividade < MAP_IDLE_PAUSE_MS) return;
      this.pausarTempoReal({ motivo: 'inatividade' });
    }, 30000);
  }

  pararVigiaInatividade() {
    if (this._idleTimer) {
      clearInterval(this._idleTimer);
      this._idleTimer = null;
    }
    if (typeof window !== 'undefined') {
      MAP_IDLE_EVENTS.forEach(evt => window.removeEventListener(evt, this.registrarAtividade));
    }
  }

  /**
   * Suspende leitura (timers + subscribe) mantendo os pins na tela. Diferente de
   * pausar: não limpa o redux, então voltar para a aba não pisca o mapa.
   */
  suspenderLeitura() {
    if (!this.state.modoTempoReal || this._suspenso) return;
    this._suspenso = true;

    if (this.state.intervaloMapaFaseGeral) {
      clearInterval(this.state.intervaloMapaFaseGeral);
    }
    if (this._httpTickWatchdog) {
      clearTimeout(this._httpTickWatchdog);
      this._httpTickWatchdog = null;
    }
    if (this._socketBootstrapTimer) {
      clearTimeout(this._socketBootstrapTimer);
      this._socketBootstrapTimer = null;
    }

    this.pararKeepaliveMapa();
    deactivateMapaFaseLive();

    this._httpTickBusy = false;
    this.setState({ intervaloMapaFaseGeral: null, mapaSocketAtivo: false });
  }

  retomarLeitura() {
    if (!this._suspenso) return;
    this._suspenso = false;

    const grupos = this.gruposSelecionados();
    if (!grupos.length) return;

    this._mapaGruposAtuais = grupos;
    this._lastHttpFullSync = 0;

    if (this.deveUsarSocketMapa()) {
      activateMapaFaseLive(grupos);
      this.startSocketBootstrap();
      this.iniciarKeepaliveMapa();
    } else {
      setMapaFaseLiveAtivo(true, grupos);
    }

    this.reiniciarIntervaloMapa();
    this.tickMapa();
  }

  /**
   * Aba oculta só suspende depois de MAP_HIDDEN_SUSPEND_MS — troca rápida de aba
   * não mexe em nada. O objetivo é liberar a ponte TCP de aba esquecida, não
   * punir quem alterna entre telas.
   */
  handleVisibilityChange() {
    if (typeof document === 'undefined') return;

    if (document.visibilityState !== 'visible') {
      if (this.state.modoTempoReal && !this._suspenso && !this._suspenderTimer) {
        this._suspenderTimer = setTimeout(() => {
          this._suspenderTimer = null;
          this.suspenderLeitura();
        }, MAP_HIDDEN_SUSPEND_MS);
      }
      return;
    }

    if (this._suspenderTimer) {
      clearTimeout(this._suspenderTimer);
      this._suspenderTimer = null;
    }

    if (!this.state.modoTempoReal) return;
    this.registrarAtividade();

    if (this._suspenso) {
      this.retomarLeitura();
      return;
    }

    this.ensureMapaSocketAtivo();
    this.tickMapa();
  }

  reiniciarIntervaloMapa() {
    if (!this.state.modoTempoReal) return;
    if (this.state.intervaloMapaFaseGeral) {
      clearInterval(this.state.intervaloMapaFaseGeral);
    }
    const id = setInterval(this.tickMapa, this.intervaloMapaMs());
    this.setState({ intervaloMapaFaseGeral: id });
  }

  handleMapaFaseSocketUpdate(payload) {
    if (!this.state.modoTempoReal) return;
    if (!payload || !Array.isArray(payload.data)) return;
    const grupoId = parseInt(payload.grupoId, 10);
    const grupos = this.gruposSelecionados();
    if (!grupos.includes(grupoId)) return;

    const isFull = payload.full !== false;
    const lista = this.props.list || [];
    const base = grupos.length > 1 ? fasesDoGrupo(lista, grupoId) : lista;

    // Patch parcial só depois do mapa base (HTTP) — evita tela só com cinzas/recovery.
    if (!isFull && base.length === 0) {
      return;
    }

    // full:true parcial (warm-up) — ignorar; remoção legítima ou authoritative aceita.
    if (isFull && !shouldAcceptMenorSnapshotFull(base, payload.data, payload.authoritative === true)) {
      return;
    }

    this.props.setMapaFaseFromSocket({
      data: payload.data,
      full: isFull,
      controladorId: payload.controladorId,
      grupoId: payload.grupoId,
      authoritative: payload.authoritative === true,
    });
  }

  handleMapaFaseSubscribed(payload) {
    if (!this.state.modoTempoReal) return;
    if (!payload || !payload.ok) return;
    if (!this.gruposSelecionados().includes(parseInt(payload.grupoId, 10))) return;
    this._lastHttpFullSync = Date.now();
    if (!this.state.mapaSocketAtivo) {
      this.setState({ mapaSocketAtivo: true, tempoRealLoading: false }, () => this.reiniciarIntervaloMapa());
    } else if (this.state.tempoRealLoading) {
      this.setState({ tempoRealLoading: false });
    }
  }

  startSocketBootstrap() {
    if (!this.state.modoTempoReal || !this.deveUsarSocketMapa()) return;
    if (this._socketBootstrapTimer) {
      clearTimeout(this._socketBootstrapTimer);
    }
    this._socketBootstrapAttempts = 0;

    const tentar = () => {
      const grupos = this.gruposSelecionados();
      if (this.deveUsarSocketMapa() && grupos.length) {
        socketService.ensureMapaFaseLive(grupos);
      }

      if (socketService.isMapaFaseSubscribedOk()) {
        grupos.forEach(gid => this.handleMapaFaseSubscribed({ ok: true, grupoId: gid }));
        this._socketBootstrapTimer = null;
        return;
      }

      this._socketBootstrapAttempts += 1;
      if (this._socketBootstrapAttempts < MAP_SOCKET_BOOTSTRAP_MAX) {
        this._socketBootstrapTimer = setTimeout(tentar, MAP_SOCKET_BOOTSTRAP_MS);
      }
    };

    tentar();
  }

  setupMapaSocket() {
    if (!this.deveUsarSocketMapa()) return;
    const grupos = this.gruposSelecionados();
    this._mapaGruposAtuais = grupos;
    if (grupos.length) {
      socketService.ensureMapaFaseLive(grupos);
    }
  }

  teardownMapaSocket() {
    if (typeof window !== 'undefined') {
      window.__mapaFaseSubscribed = null;
    }
  }

  // Método para processar dados pluviométricos com lógica de "hold"
  processarDadosPluviometricos(novosDados) {
    const dadosAnteriores = this.state.pluviometroDataAnterior || [];

    return novosDados.map(novoItem => {
      // Encontrar item correspondente nos dados anteriores
      const itemAnterior = dadosAnteriores.find(anterior => anterior.controlador_id === novoItem.controlador_id);

      // Se o período usado é "15min_hold", manter dados anteriores se existirem
      if (novoItem.periodo_usado === '15min_hold' && itemAnterior) {
        return {
          ...novoItem,
          // Manter visualização anterior para evitar mudanças bruscas
          chuva_display: itemAnterior.chuva_display || novoItem.chuva_display,
          intensidade_chuva: itemAnterior.intensidade_chuva || novoItem.intensidade_chuva,
          cor_intensidade: itemAnterior.cor_intensidade || novoItem.cor_intensidade,
        };
      }

      // Caso contrário, usar os novos dados
      return novoItem;
    });
  }

  pausarTempoReal(opts = {}) {
    const grupos = this._mapaGruposAtuais.length ? this._mapaGruposAtuais : this.gruposSelecionados();
    const porInatividade = opts && opts.motivo === 'inatividade';

    if (this.state.intervaloMapaFaseGeral) {
      clearInterval(this.state.intervaloMapaFaseGeral);
    }
    if (this._httpTickWatchdog) {
      clearTimeout(this._httpTickWatchdog);
      this._httpTickWatchdog = null;
    }
    if (this._socketBootstrapTimer) {
      clearTimeout(this._socketBootstrapTimer);
      this._socketBootstrapTimer = null;
    }

    if (this._suspenderTimer) {
      clearTimeout(this._suspenderTimer);
      this._suspenderTimer = null;
    }
    this._suspenso = false;

    this.pararKeepaliveMapa();
    this.pararVigiaInatividade();

    if (this.deveUsarSocketMapa()) {
      grupos.forEach(gid => socketService.unsubscribeMapaFase(gid));
    }

    deactivateMapaFaseLive();
    this.props.setMapaFaseLive(false);
    this.props.clearMapaFase(grupos);

    this._httpTickBusy = false;
    this._lastHttpFullSync = 0;
    this._mapaGruposAtuais = [];

    if (typeof window !== 'undefined') {
      window.__mapaFaseSubscribed = null;
    }

    this.setState({
      modoTempoReal: false,
      tempoRealLoading: false,
      mapaSocketAtivo: false,
      intervaloMapaFaseGeral: null,
      openInfoWindowMarkerId: '',
      selectedMarkerData: null,
      pluviometroData: [],
      pluviometroDataAnterior: [],
      pausadoPorInatividade: porInatividade,
    }, () => {
      this.carregarControladoresMapa();
    });
  }

  iniciarTempoReal(opts = {}) {
    const grupos = this.gruposSelecionados();

    if (!grupos.length) {
      if (!opts || !opts.silencioso) {
        toastr.warning('Atenção', 'Selecione um grupo físico antes de iniciar a leitura em tempo real.');
      }
      return;
    }

    if (this.state.modoTempoReal) return;

    this.setState({ modoTempoReal: true, tempoRealLoading: true, pausadoPorInatividade: false }, () => {
      this.props.setMapaFaseLive(true);
      this.props.clearMapaFase(grupos);
      this._lastHttpFullSync = 0;
      this._mapaGruposAtuais = grupos;

      wireMapaFaseSocketBridge();

      if (typeof window !== 'undefined') {
        window.__mapaFaseSubscribed = payload => this.handleMapaFaseSubscribed(payload);
      }

      if (this.deveUsarSocketMapa()) {
        activateMapaFaseLive(grupos);
        this.startSocketBootstrap();
        this.iniciarKeepaliveMapa();
      } else {
        setMapaFaseLiveAtivo(true, grupos);
      }

      this.iniciarVigiaInatividade();
      this.reiniciarIntervaloMapa();
      this.tickMapa();

      setTimeout(() => {
        if (this.state.modoTempoReal) {
          this.setState({ tempoRealLoading: false });
        }
      }, 1500);
    });
  }

  componentDidMount() {
    this.props.setMapaFaseLive(false);
    this.props.clearMapaFase(this.gruposSelecionados());
    deactivateMapaFaseLive();
    wireMapaFaseSocketBridge();

    if (!this.state.googleMapsReady) {
      this.googleMapsReadyInterval = setInterval(() => {
        if (typeof window !== 'undefined' && window.google && window.google.maps) {
          clearInterval(this.googleMapsReadyInterval);
          this.googleMapsReadyInterval = null;
          this.setState({ googleMapsReady: true });
        }
      }, 300);
    }

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    this.blinkInterval = setInterval(() => {
      this.setState(prev => ({ blinkOn: !prev.blinkOn }));
    }, 600);

    if (typeof document === 'undefined' || document.visibilityState === 'visible') {
      this.carregarControladoresMapa();
    }
  }

  componentDidUpdate(prevProps) {
    const configAgora = this.props.config && this.props.config.mapa_fase_socket;
    const configAntes = prevProps.config && prevProps.config.mapa_fase_socket;
    const socketLigou = this.deveUsarSocketMapa() && !configAntes && configAgora;

    if (socketLigou || (configAgora && !this._mapaSocketConfigOk)) {
      this._mapaSocketConfigOk = true;
      if (this.state.modoTempoReal) {
        this.startSocketBootstrap();
        this.reiniciarIntervaloMapa();
      }
    }

    if (
      this.state.modoTempoReal &&
      this.deveUsarSocketMapa() &&
      configAgora &&
      !socketService.isMapaFaseSubscribedOk()
    ) {
      this.ensureMapaSocketAtivo();
    }

    // "Todos os grupos" depende da lista de grupos, que chega por HTTP. Se ela
    // ainda não estava carregada na seleção, liga assim que chegar.
    const listaAntes = (prevProps.listGrupoFisico || []).length;
    const listaAgora = (this.props.listGrupoFisico || []).length;
    if (
      this.state.todosGrupos &&
      !this.state.modoTempoReal &&
      listaAgora > listaAntes
    ) {
      this.carregarControladoresMapa();
    }
  }

  componentWillUnmount() {
    this.pausarTempoReal();
    this.pararVigiaInatividade();
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    if (this.googleMapsReadyInterval) {
      clearInterval(this.googleMapsReadyInterval);
    }
    clearInterval(this.blinkInterval);
    if (this._panoramaListener && window.google && window.google.maps) {
      window.google.maps.event.removeListener(this._panoramaListener);
    }
  }

  onMapLoad(mapRef) {
    if (!mapRef) return;
    this._googleMapRef = mapRef;
    try {
      mapRef.setMapTypeId(this.state.mapTypeId || 'roadmap');
      const panorama = mapRef.getStreetView();
      this._panoramaListener = window.google.maps.event.addListener(panorama, 'visible_changed', () => {
        this.setState({ isStreetView: panorama.getVisible(), selectedMarkerData: null });
      });
    } catch (e) {}
  }

  handleToggleOpen(markerId, controladorId, faseId, data) {
    this.setState({
      openInfoWindowMarkerId: markerId,
      selectedMarkerData: data || null,
    });
  }

  handleToggleClose() {
    this.setState({
      openInfoWindowMarkerId: '',
      selectedMarkerData: null,
    });
  }

  renderInfoRow(label, value, icon, valueClassName = '') {
    if (value === undefined || value === null || value === '') return null;

    return (
      <div className="mapa-fases-info-row">
        <span className="mapa-fases-info-row-label">{label}</span>
        <span className={`mapa-fases-info-row-value ${valueClassName}`}>{value}</span>
      </div>
    );
  }

  renderInfoWindow(data, position = null) {
    // Se módulo pluviométrico está desabilitado, sempre usar modo fases
    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';

    const planoAtual =
      data.plano_atu || (data.plano_id !== undefined && data.plano_id !== null ? `${data.plano_id}` : '');
    const proximoPlano = data.plano_pro || data.hora_proximo_plano || '';

    // InfoWindow específica para modo pluviométrico
    if (modoPluviometrico) {
      const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
      const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';
      const chuva = `${parseFloat(data.chuva_display || data.chuva_15min || 0).toFixed(2)}mm`;
      const periodo = data.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min';

      return (
        <InfoWindow
          position={position || { lat: parseFloat(data.fase_latitude), lng: parseFloat(data.fase_longitude) }}
          onCloseClick={() => this.handleToggleClose()}
        >
          <div className="mapa-fases-info-window">
            <div className="mapa-fases-info-header">
              <div>
                <strong>Controlador {data.numero_controlador}</strong>
                <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
              </div>
            </div>
            <div className="mapa-fases-info-body">
              {this.renderInfoRow('Endereço', data.endereco || 'Não informado', 'fa-map-marker')}
              {this.renderInfoRow('Chuva', chuva, 'fa-tint', 'is-highlight')}
              {this.renderInfoRow('Período', periodo, 'fa-clock-o')}
              {this.renderInfoRow('Latitude', data.fase_latitude, 'fa-location-arrow')}
              {this.renderInfoRow('Longitude', data.fase_longitude, 'fa-location-arrow')}
            </div>
          </div>
        </InfoWindow>
      );
    }

    // InfoWindow padrão para modo fases
    const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
    const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';
    const tipoControlador = parseInt(data.tipo) !== 1 ? 'Travessia de Pedestre' : 'Semafórico';

    return (
      <InfoWindow onCloseClick={() => this.handleToggleClose()}>
        <div className="mapa-fases-info-window">
          <div className="mapa-fases-info-header">
            <div>
              <strong>Controlador {data.numero_controlador}</strong>
              <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
            </div>
          </div>
          <div className="mapa-fases-info-body">
            {this.renderInfoRow('Tipo', tipoControlador, 'fa-road', parseInt(data.tipo) !== 1 ? 'is-highlight' : '')}
            {this.renderInfoRow('Endereço', data.controlador_endereco || 'Não informado', 'fa-map-marker')}
            {this.renderInfoRow('Anel', data.anel, 'fa-circle-o')}
            {this.renderInfoRow('Fase', data.fase_id, 'fa-random')}
            {corPiscanteIntervaloAtiva(data)
              ? this.renderInfoRow(
                  'Estado',
                  `${corPiscanteIntervaloAtiva(data)} piscante`,
                  'fa-warning',
                  'is-highlight',
                )
              : null}
            {this.renderInfoRow('IP', data.controlador_ip, 'fa-wifi')}
            {this.renderInfoRow('Porta', data.controlador_porta, 'fa-plug')}
            {planoAtual ? this.renderInfoRow('Plano Atual', planoAtual, 'fa-clock-o', 'is-highlight') : null}
            {proximoPlano ? this.renderInfoRow('Próximo Plano', proximoPlano, 'fa-forward') : null}
            {this.renderInfoRow('Latitude', data.fase_latitude, 'fa-location-arrow')}
            {this.renderInfoRow('Longitude', data.fase_longitude, 'fa-location-arrow')}
          </div>
          {data.croqui_file_id && (
            <div className="mapa-fases-info-actions">
              <Button
                onClick={() => downloadCroqui(data.croqui_file_id)}
                bsSize="xsmall"
                className="mapa-fases-info-download"
              >
                Baixar croqui
              </Button>
            </div>
          )}
        </div>
      </InfoWindow>
    );
  }

  renderMarcadoresControladorPausado() {
    return renderMarcadoresControlador({
      controladores: this.state.controladoresMapa,
      markerAberto: this.state.openInfoWindowMarkerId,
      onAbrir: id => this.setState({ openInfoWindowMarkerId: id, selectedMarkerData: null }),
      onFechar: this.handleToggleClose,
      onDetalhes: this.handleDetalhesControlador,
      onReset: this.solicitarResetControlador,
    });
  }

  renderMarker() {
    // Se módulo pluviométrico está desabilitado, sempre usar modo fases
    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';

    if (!this.state.modoTempoReal) {
      return this.renderMarcadoresControladorPausado();
    }

    // Se está no modo pluviométrico, usar dados pluviométricos
    let list = modoPluviometrico ? this.state.pluviometroData : this.props.list || [];

    // Ordem estável: pins com mesmas coordenadas (bancada) não trocam de controlador
    // visível conforme patches do socket reordenam o array.
    if (!modoPluviometrico && list.length > 1) {
      list = [...list].sort((a, b) => {
        const na = parseInt(a.numero_controlador, 10) || 0;
        const nb = parseInt(b.numero_controlador, 10) || 0;
        if (na !== nb) return na - nb;
        return (parseInt(a.fase_id, 10) || 0) - (parseInt(b.fase_id, 10) || 0);
      });
    }

    // No modo pluviométrico, agrupar por controlador (apenas 1 nuvem por localização)
    if (modoPluviometrico) {
      const controladorMap = {};
      list.forEach(item => {
        const controladorId = item.controlador_id;
        if (!controladorMap[controladorId] || item.anel === 1) {
          // Priorizar anel 1 ou primeiro encontrado
          controladorMap[controladorId] = item;
        }
      });
      list = Object.values(controladorMap);
    }

    if (!modoPluviometrico) {
      return coletarPinsFase(list, {
        mapZoom: this.state.mapZoom,
        blinkOn: this.state.blinkOn,
      }).map(pin =>
        this.newMarker(
          pin.key,
          pin.position,
          pin.icon,
          pin.controlador_id,
          pin.fase_id,
          pin.data,
          false,
          pin.shape,
        ),
      );
    }

    const markers = [];
    for (var key in list) {
      let position = {};
      if (list[key].fase_latitude !== null && list[key].fase_latitude !== undefined) {
        position = { lat: parseFloat(list[key].fase_latitude), lng: parseFloat(list[key].fase_longitude) };
      }
      const controlador_id = list[key].controlador_id;
      const fase_id = list[key].fase_id;
      const icon_cor = ImgPedestrianGrey;
      markers.push(
        this.newMarker(`${controlador_id}`, position, icon_cor, controlador_id, fase_id, list[key], true),
      );
    }

    return markers;
  }

  newMarker(contKey, position, icon_cor, controlador_id, fase_id, data, isCloudIcon = false, markerShape = undefined) {
    if (isCloudIcon && data.tem_dados_pluviometricos) {
      // Renderizar como CloudOverlay
      return (
        <CloudOverlay
          key={contKey}
          position={position}
          data={data}
          onClick={() => this.handleToggleOpen(contKey, controlador_id, fase_id, data)}
        >
          {this.state.openInfoWindowMarkerId === contKey && this.renderInfoWindow(data, position)}
        </CloudOverlay>
      );
    } else {
      return (
        <Marker
          key={contKey}
          position={position}
          icon={icon_cor}
          shape={markerShape}
          onClick={() => this.handleToggleOpen(contKey, controlador_id, fase_id, data)}
        >
          {this.state.openInfoWindowMarkerId === contKey && this.renderInfoWindow(data)}
        </Marker>
      );
    }
  }

  renderStreetViewTooltip() {
    const data = this.state.selectedMarkerData;
    if (!data) return null;

    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';
    const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
    const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';

    let content;
    if (modoPluviometrico) {
      const chuva = `${parseFloat(data.chuva_display || data.chuva_15min || 0).toFixed(2)}mm`;
      const periodo = data.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min';
      content = (
        <div className="mapa-fases-info-body">
          {this.renderInfoRow('Endereço', data.endereco || 'Não informado')}
          {this.renderInfoRow('Chuva', chuva, '', 'is-highlight')}
          {this.renderInfoRow('Período', periodo)}
          {this.renderInfoRow('Latitude', data.fase_latitude)}
          {this.renderInfoRow('Longitude', data.fase_longitude)}
        </div>
      );
    } else {
      const planoAtual =
        data.plano_atu || (data.plano_id !== undefined && data.plano_id !== null ? `${data.plano_id}` : '');
      const proximoPlano = data.plano_pro || data.hora_proximo_plano || '';
      const tipoControlador = parseInt(data.tipo) !== 1 ? 'Travessia de Pedestre' : 'Semafórico';
      content = (
        <>
          <div className="mapa-fases-info-body">
            {this.renderInfoRow('Tipo', tipoControlador, '', parseInt(data.tipo) !== 1 ? 'is-highlight' : '')}
            {this.renderInfoRow('Endereço', data.controlador_endereco || 'Não informado')}
            {this.renderInfoRow('Anel', data.anel)}
            {this.renderInfoRow('Fase', data.fase_id)}
            {corPiscanteIntervaloAtiva(data)
              ? this.renderInfoRow(
                  'Estado',
                  `${corPiscanteIntervaloAtiva(data)} piscante`,
                  '',
                  'is-highlight',
                )
              : null}
            {this.renderInfoRow('IP', data.controlador_ip)}
            {this.renderInfoRow('Porta', data.controlador_porta)}
            {planoAtual ? this.renderInfoRow('Plano Atual', planoAtual, '', 'is-highlight') : null}
            {proximoPlano ? this.renderInfoRow('Próximo Plano', proximoPlano) : null}
            {this.renderInfoRow('Latitude', data.fase_latitude)}
            {this.renderInfoRow('Longitude', data.fase_longitude)}
          </div>
          {data.croqui_file_id && (
            <div className="mapa-fases-info-actions">
              <Button
                onClick={() => downloadCroqui(data.croqui_file_id)}
                bsSize="xsmall"
                className="mapa-fases-info-download"
              >
                Baixar croqui
              </Button>
            </div>
          )}
        </>
      );
    }

    return (
      <div
        style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          zIndex: 1000,
          borderRadius: '16px',
          boxShadow: '0 18px 45px rgba(15,23,42,0.2)',
          overflow: 'hidden',
          pointerEvents: 'auto',
        }}
      >
        <div className="mapa-fases-info-window">
          <div className="mapa-fases-info-header">
            <div>
              <strong>Controlador {data.numero_controlador}</strong>
              <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
            </div>
            <button
              onClick={this.handleToggleClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0 0 0 12px',
                fontSize: '20px',
                color: '#64748b',
                lineHeight: 1,
                alignSelf: 'flex-start',
              }}
            >
              ×
            </button>
          </div>
          {content}
        </div>
      </div>
    );
  }

  changeGrupo(valor) {
    if (this.state.modoTempoReal) {
      this.pausarTempoReal();
    }

    this.props.getConfControladorGrupoList();
    this._pausadoManualmente = false;

    this.setState(
      {
        todosGrupos: valor === GRUPO_TODOS,
        openInfoWindowMarkerId: '',
        selectedMarkerData: null,
        // Centro anterior é mantido de propósito: zerar aqui fazia o mapa sumir e
        // exibir "Nenhum controlador cadastrado" durante a busca do novo centro.
        carregandoInicioMapa: true,
        erroCarregamentoMapa: null,
        pluviometroData: [],
        pluviometroDataAnterior: [],
        pausadoPorInatividade: false,
        gavetaControlador: null,
      },
      () => {
        this.props
          .getInicioMapa(this.grupoParaInicioMapa())
          .then(response => {
            if (parseInt(response.payload.data.latitude, 10) === 1) {
              swal({
                type: 'warning',
                title: 'Grupo físico sem controlador cadastrado!',
              });
            }
            this.setState({ inicioMapa: this.props.inicioMapa, carregandoInicioMapa: false });
          })
          .catch(() =>
            this.setState({
              carregandoInicioMapa: false,
              erroCarregamentoMapa:
                'Não foi possível carregar o grupo. O servidor MySQL pode estar sem conexões disponíveis.',
            }),
          );

        this.carregarControladoresMapa();
      },
    );
  }

  pausarManualmente() {
    this._pausadoManualmente = true;
    this.pausarTempoReal();
  }

  retomarManualmente() {
    this._pausadoManualmente = false;
    this.iniciarTempoReal();
  }

  handleZoomChanged(zoom) {
    if (zoom !== this.state.mapZoom) {
      clearArrowIconCache();
      this.setState({ mapZoom: zoom });
    }
  }

  changeDisplayTraffic() {
    const traffic = this.state.displayTraffic;
    this.setState({ displayTraffic: !traffic });
  }

  changeMapType(mapTypeId) {
    if (this.state.mapTypeId === mapTypeId) return;
    this.setState({ mapTypeId });
    if (this._googleMapRef && this._googleMapRef.setMapTypeId) {
      this._googleMapRef.setMapTypeId(mapTypeId);
    }
  }

  changeVisualizacao(event) {
    const novoTipo = event.target.value;

    if (novoTipo === 'pluviometrico' && (!this.props.config || !this.props.config.modulo_pluviometrico)) {
      return;
    }

    this.setState({ tipoVisualizacao: novoTipo });

    if (!this.state.modoTempoReal) return;

    if (novoTipo === 'pluviometrico') {
      if (this.props.config && this.props.config.mapa_fase_socket) {
        deactivateMapaFaseLive();
        this._mapaGruposAtuais.forEach(gid => socketService.unsubscribeMapaFase(gid));
      }
      this.props
        .getPluviometroMapaData(this.grupoParaInicioMapa())
        .then(response => {
          this.setState({ pluviometroData: response.payload.data || [] });
        })
        .catch(() => {
          this.setState({ tipoVisualizacao: 'fases' });
        });
    } else {
      const grupos = this.gruposSelecionados();
      setMapaFaseLiveAtivo(true, grupos);
      this.setupMapaSocket();
      if (this.deveUsarSocketMapa()) {
        activateMapaFaseLive(grupos);
        this.startSocketBootstrap();
      }
      this.tickMapa();
    }
  }

  render() {
    let inicioMapa = this.state.inicioMapa;
    let hasValidCoordinates = inicioMapa.latitude && inicioMapa.longitude;

    return (
      <div className="mapa-fases-premium">
        <div className="mapa-fases-toolbar">
          <div className="mapa-fases-toolbar__row">
            <div className="mapa-fases-toolbar__filters">
              <div className="mapa-fases-toolbar__filter">
                <span className="mapa-fases-toolbar__filter-label">Grupo Físico</span>
                {this.state.tipoVisualizacao === 'pluviometrico' ? (
                  <SelectConfGrupoFisicoPluviometro
                    onChange={this.changeGrupo}
                    emptyText="Selecione"
                    customStyle={MAPA_SELECT_STYLE}
                  />
                ) : (
                  <SelectConfGrupoFisico
                    onChange={this.changeGrupo}
                    emptyText="Selecione"
                    todosText="0 - Todos os grupos"
                    customStyle={MAPA_SELECT_STYLE}
                  />
                )}
              </div>

              <div className="mapa-fases-toolbar__filter">
                <span className="mapa-fases-toolbar__filter-label">Tráfego</span>
                <label className="mapa-fases-toolbar__traffic-toggle">
                  <input type="checkbox" checked={this.state.displayTraffic} onChange={this.changeDisplayTraffic} />
                  <span
                    className={`mapa-fases-toolbar__traffic-track${
                      this.state.displayTraffic ? ' mapa-fases-toolbar__traffic-track--on' : ''
                    }`}
                  >
                    <span
                      className={`mapa-fases-toolbar__traffic-thumb${
                        this.state.displayTraffic ? ' mapa-fases-toolbar__traffic-thumb--on' : ''
                      }`}
                    />
                  </span>
                </label>
              </div>

              <div className="mapa-fases-toolbar__filter">
                <span className="mapa-fases-toolbar__filter-label">Visualização</span>
                <div className="mapa-fases-toolbar__maptype" role="group" aria-label="Tipo de mapa">
                  <button
                    type="button"
                    className={`mapa-fases-toolbar__maptype-btn${
                      this.state.mapTypeId === 'roadmap' ? ' mapa-fases-toolbar__maptype-btn--active' : ''
                    }`}
                    onClick={() => this.changeMapType('roadmap')}
                  >
                    Mapa
                  </button>
                  <button
                    type="button"
                    className={`mapa-fases-toolbar__maptype-btn${
                      this.state.mapTypeId === 'satellite' ? ' mapa-fases-toolbar__maptype-btn--active' : ''
                    }`}
                    onClick={() => this.changeMapType('satellite')}
                  >
                    Satélite
                  </button>
                  <button
                    type="button"
                    className="mapa-fases-toolbar__maptype-btn mapa-fases-toolbar__export-btn"
                    onClick={this.exportarKmz}
                    disabled={this.state.exportandoKmz || this.state.tipoVisualizacao === 'pluviometrico'}
                    title="Exportar KMZ (posições e setas)"
                    aria-label="Exportar KMZ"
                  >
                    <i
                      className={`fa ${this.state.exportandoKmz ? 'fa-spinner fa-spin' : 'fa-download'}`}
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="mapa-fases-toolbar__live">
              <button
                type="button"
                className={`mapa-fases-toolbar__live-btn${
                  this.state.modoTempoReal ? ' mapa-fases-toolbar__live-btn--on' : ' mapa-fases-toolbar__live-btn--off'
                }${this.state.tempoRealLoading ? ' mapa-fases-toolbar__live-btn--loading' : ''}`}
                onClick={this.state.modoTempoReal ? this.pausarManualmente : this.retomarManualmente}
                disabled={this.state.tempoRealLoading}
                title={
                  this.state.tempoRealLoading
                    ? 'Conectando…'
                    : this.state.modoTempoReal
                      ? 'Pausar leitura'
                      : 'Iniciar leitura'
                }
                aria-label={
                  this.state.tempoRealLoading
                    ? 'Conectando leitura ao vivo'
                    : this.state.modoTempoReal
                      ? 'Pausar leitura ao vivo'
                      : 'Iniciar leitura ao vivo'
                }
              >
                <span className="mapa-fases-toolbar__live-btn-ring" aria-hidden="true" />
                <i
                  className={`fa mapa-fases-toolbar__live-btn-icon ${
                    this.state.tempoRealLoading
                      ? 'fa-spinner fa-spin'
                      : this.state.modoTempoReal
                        ? 'fa-pause'
                        : 'fa-play'
                  }`}
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
        <div className="mapa-fases-premium-content" style={{ padding: '0 10px', margin: '0' }}>
          <div
            className="mapa-fases-premium-layout"
            style={{
              display: 'flex',
              height: 'calc(100vh - 100px)',
              gap: '15px',
            }}
          >
            {/* Mapa principal */}
            <div
              className="mapa-fases-premium-map-card"
              style={{
                flex: 1,
                position: 'relative',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                overflow: 'hidden',
              }}
            >
              {!this.state.googleMapsReady ? (
                <div
                  className="mapa-fases-premium-empty"
                  style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                    color: '#6c757d',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ fontSize: '42px', marginBottom: '20px', opacity: 0.6 }}
                    />
                    <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Carregando Google Maps</h4>
                    <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>Aguarde enquanto o mapa é preparado.</p>
                  </div>
                </div>
              ) : hasValidCoordinates ? (
                <>
                  <MapaGoogle
                    containerElement={<div style={{ height: '100%', width: '100%' }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    defaultCenter={{ lat: inicioMapa.latitude, lng: inicioMapa.longitude }}
                    displayTraffic={this.state.displayTraffic}
                    options={{ mapTypeControl: false, mapTypeId: this.state.mapTypeId }}
                    onZoomChanged={this.handleZoomChanged}
                    onMapLoad={this.onMapLoad}
                  >
                    {this.renderMarker()}
                  </MapaGoogle>
                  {!this.state.modoTempoReal && (
                    <div
                      className="mapa-fases-premium-paused-overlay"
                      style={{
                        position: 'absolute',
                        top: '12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 5,
                        background: 'rgba(255, 255, 255, 0.95)',
                        border: '1px solid #e9ecef',
                        borderRadius: '6px',
                        padding: '10px 16px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        fontSize: '13px',
                        color: '#495057',
                        textAlign: 'center',
                        maxWidth: '90%',
                      }}
                    >
                      <i className="fa fa-pause-circle" style={{ marginRight: '8px', color: '#6c757d' }} />
                      {this.state.carregandoControladores ? (
                        <>
                          <i className="fa fa-spinner fa-spin" style={{ marginRight: 8 }} />
                          Carregando controladores…
                        </>
                      ) : this.state.pausadoPorInatividade ? (
                        <>
                          Pausado por inatividade. <strong>Iniciar leitura</strong> para ver fases ao vivo.
                        </>
                      ) : (
                        <>
                          Modo controladores (cadastro). <strong>Iniciar leitura</strong> para fases ao vivo no mapa.
                        </>
                      )}
                    </div>
                  )}
                  {this.state.modoTempoReal && this.state.tempoRealLoading && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 5,
                        background: 'rgba(255, 255, 255, 0.95)',
                        border: '1px solid #e9ecef',
                        borderRadius: '6px',
                        padding: '8px 14px',
                        fontSize: '13px',
                        color: '#495057',
                      }}
                    >
                      <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }} />
                      Carregando fases...
                    </div>
                  )}
                </>
              ) : (
                <div
                  className="mapa-fases-premium-empty"
                  style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                    color: '#6c757d',
                  }}
                >
                  {this.state.carregandoInicioMapa ? (
                    <div style={{ textAlign: 'center' }}>
                      <i
                        className="fa fa-spinner fa-spin"
                        style={{ fontSize: '42px', marginBottom: '20px', opacity: 0.6 }}
                      />
                      <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Carregando grupo físico</h4>
                      <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>Localizando os controladores no mapa.</p>
                    </div>
                  ) : this.state.erroCarregamentoMapa ? (
                    <div style={{ textAlign: 'center', maxWidth: '420px', padding: '0 16px' }}>
                      <i
                        className="fa fa-exclamation-triangle"
                        style={{ fontSize: '42px', marginBottom: '20px', color: '#b45309', opacity: 0.85 }}
                      />
                      <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Servidor de dados indisponível</h4>
                      <p style={{ margin: 0, fontSize: '14px', opacity: 0.85 }}>{this.state.erroCarregamentoMapa}</p>
                      <p style={{ margin: '12px 0 0', fontSize: '12px', opacity: 0.75 }}>
                        No hosting, reinicie o MySQL ou encerre conexões ociosas (erro &quot;Too many connections&quot;).
                      </p>
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center' }}>
                      <i
                        className="fa fa-info-circle"
                        style={{ fontSize: '48px', marginBottom: '20px', opacity: 0.5 }}
                      />
                      <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Nenhum controlador cadastrado</h4>
                      <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                        Selecione outro grupo físico para visualizar os controladores no mapa.
                      </p>
                    </div>
                  )}
                </div>
              )}
              {this.state.isStreetView && this.renderStreetViewTooltip()}
            </div>

            {/* Painel lateral pluviométrico - só aparece se módulo estiver habilitado */}
            {this.props.config &&
              this.props.config.modulo_pluviometrico &&
              this.state.tipoVisualizacao === 'pluviometrico' && (
                <div
                  className="mapa-fases-premium-rain-panel"
                  style={{
                    width: '300px',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e9ecef',
                    borderRadius: '4px',
                    padding: '15px',
                    overflowY: 'auto',
                  }}
                >
                  <h5
                    style={{
                      marginBottom: '20px',
                      color: '#495057',
                      fontWeight: '500',
                      fontSize: '16px',
                      borderBottom: '1px solid #f1f3f4',
                      paddingBottom: '12px',
                    }}
                  >
                    <i className="fa fa-cloud-rain" style={{ marginRight: '8px', color: '#6c757d' }} />
                    Análise Pluviométrica (15min)
                  </h5>
                  {/* Legenda de intensidades */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Intensidade da Chuva</h6>
                    <div style={{ fontSize: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <i
                          className="fa fa-sun"
                          style={{
                            fontSize: '16px',
                            color: '#FFD700',
                            marginRight: '8px',
                            width: '20px',
                            textAlign: 'center',
                          }}
                        />
                        <span>Sem Chuva: 0mm (Sol)</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#90EE90',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Fraca: 0.1 - 1.25mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FFD700',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Moderada: 1.25 - 6.25mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FF8C00',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Forte: 6.25 - 12.5mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FF0000',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Muito Forte: {'>'} 12.5mm</span>
                      </div>
                    </div>
                  </div>

                  {/* Resumo dos dados */}
                  {this.state.pluviometroData.length > 0 &&
                    (() => {
                      // Agrupa controladores únicos para o resumo
                      const controladoresUnicos = this.state.pluviometroData.reduce((acc, item) => {
                        const existing = acc.find(x => x.numero_controlador === item.numero_controlador);
                        if (!existing) {
                          acc.push(item);
                        } else {
                          // Mantém o maior valor de chuva se houver múltiplos anéis
                          if (item.chuva_15min > existing.chuva_15min) {
                            Object.assign(existing, item);
                          }
                        }
                        return acc;
                      }, []);

                      return (
                        <div>
                          <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>
                            Resumo dos Dados
                          </h6>
                          <div
                            style={{
                              fontSize: '12px',
                              backgroundColor: 'white',
                              padding: '10px',
                              borderRadius: '4px',
                              border: '1px solid #dee2e6',
                            }}
                          >
                            <div>
                              <strong>Total de controladores:</strong> {controladoresUnicos.length}
                            </div>
                            <div>
                              <strong>Com chuva ativa:</strong>{' '}
                              {controladoresUnicos.filter(d => (d.chuva_display || d.chuva_15min) > 0).length > 0
                                ? 'Sim'
                                : 'Não'}
                            </div>
                            <div>
                              <strong>Chuva máxima:</strong>{' '}
                              {Math.max(...controladoresUnicos.map(d => d.chuva_display || d.chuva_15min)).toFixed(2)}mm
                            </div>
                            <div>
                              <strong>Chuva média:</strong>{' '}
                              {(
                                controladoresUnicos.reduce((sum, d) => sum + (d.chuva_display || d.chuva_15min), 0) /
                                controladoresUnicos.length
                              ).toFixed(2)}
                              mm
                            </div>
                          </div>
                        </div>
                      );
                    })()}

                  {/* Lista de controladores */}
                  {this.state.pluviometroData.length > 0 && (
                    <div style={{ marginTop: '15px' }}>
                      <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Controladores</h6>
                      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {this.state.pluviometroData
                          // Agrupa por controlador (remove duplicatas por anel)
                          .reduce((acc, item) => {
                            const existing = acc.find(x => x.numero_controlador === item.numero_controlador);
                            if (!existing) {
                              acc.push(item);
                            } else {
                              // Mantém o maior valor de chuva se houver múltiplos anéis
                              const itemChuva = item.chuva_display || item.chuva_15min;
                              const existingChuva = existing.chuva_display || existing.chuva_15min;
                              if (itemChuva > existingChuva) {
                                Object.assign(existing, item);
                              }
                            }
                            return acc;
                          }, [])
                          .sort((a, b) => (b.chuva_display || b.chuva_15min) - (a.chuva_display || a.chuva_15min))
                          .map((item, index) => (
                            <div
                              key={`controlador-${item.numero_controlador}`}
                              style={{
                                fontSize: '11px',
                                padding: '8px',
                                marginBottom: '5px',
                                backgroundColor: 'white',
                                border: '1px solid #dee2e6',
                                borderRadius: '3px',
                                borderLeft: `4px solid ${item.cor_intensidade}`,
                              }}
                            >
                              <div>
                                <strong>Controlador {item.numero_controlador}</strong>
                              </div>
                              <div>Chuva: {parseFloat(item.chuva_display || item.chuva_15min).toFixed(2)}mm</div>
                              <div style={{ fontSize: '10px', color: '#6c757d' }}>
                                {item.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min'}
                              </div>
                              <div>Status: {item.status_conexao <= 1 ? 'Conectado' : 'Desconectado'}</div>
                              {item.ultima_leitura && (
                                <div style={{ fontSize: '10px', color: '#6c757d' }}>
                                  Última: {new Date(item.ultima_leitura).toLocaleTimeString()}
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  {this.state.pluviometroData.length === 0 && (
                    <div style={{ textAlign: 'center', color: '#6c757d', fontSize: '12px', marginTop: '20px' }}>
                      <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                      Nenhum controlador com pluviômetro encontrado
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>

        {this.state.gavetaControlador ? (
          <MapaControladorGaveta
            controlador={this.state.gavetaControlador}
            grupoFisicoId={
              this.state.gavetaControlador.grupo_fisico_id || parseInt(getConfig('grupo'), 10) || 0
            }
            googleMapsReady={this.state.googleMapsReady}
            onClose={this.fecharGavetaControlador}
          />
        ) : null}

        <ActionConfirmModal
          show={!!this.state.resetControladorAlvo}
          title="Atenção"
          message="Deseja resetar o controlador?"
          confirmLabel="OK"
          icon="exclamation-triangle"
          destructive
          onConfirm={this.confirmarResetControlador}
          onCancel={this.cancelarResetControlador}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.faseCad.listMap,
  controladorCoresGF: state.faseCad.listMap,
  inicioMapa: state.faseCad.inicioMapa,
  pluviometroMapaData: state.faseCad.pluviometroMapaData,
  config: state.auth.config,
  listGrupoFisico: state.grupoFisicoCad.list,
  listGrupoFisicoPluviometro: state.selectdb.listGrupoFisicoPluviometro,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getControladorFase,
      getControladorCoresGF,
      getControladorCoresGT,
      clearMapaFase,
      getInicioMapa,
      getPluviometroMapaData,
      setMapaFaseFromSocket,
      setMapaFaseLive,
      getConfControladorGrupoList,
      getGrupoFisicoPluviometroList,
      getConfControladorGrupoPluviometroList,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapaFaseGeral);
